import {
  Box, Typography, useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { CSSProperties } from 'react';
import {
  selectHdDesktopOnboardShowIsDoneState,
  setHdDesktopOnboardShowIsDoneState,
  updateNavigationFromOnboarding,
} from '../../../../store/slices/onboardingSlice';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { TestIds } from '../../../../assets/testIds';
import { useCustomEventTracking } from '../../../../common/useCustomEventTracking';
import { useOnboardingRedirectPath } from '../../../../common/useOnboardingRedirectPath';
import { isUserInitiatedHomeDepotEnrollment } from '../../../../common/homeDepotEnrollmentIntent';

interface PostponeHdSetupProps{
  optionalTextStyles?: CSSProperties
}

export function PostponeHdSetup({ optionalTextStyles }:PostponeHdSetupProps) {
  const { t } = useTranslation();
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const hdDesktopOnboardShowIsDoneState = useAppSelector(selectHdDesktopOnboardShowIsDoneState);
  const location = useLocation();
  const navigate = useNavigate();
  const { trackPartnerEnrollment } = useCustomEventTracking();
  // get redirect path on optimizely decision
  const redirectPath = useOnboardingRedirectPath({
    redirectToPartnersForOnboardingFlowTestOff: true,
  });
  const onClickHandler = () => {
    const userInitiatedHdEnrollment = isUserInitiatedHomeDepotEnrollment({
      state: location.state,
      search: location.search,
    });
    if (!userInitiatedHdEnrollment) {
      dispatch(updateNavigationFromOnboarding(true));
    }
    // fire event indicating that user opted to skip home depot enrollment
    trackPartnerEnrollment('Click', 'SkipHomeDepotSetup');

    if (hdDesktopOnboardShowIsDoneState) {
      // clear store state
      dispatch(setHdDesktopOnboardShowIsDoneState(false));
    }

    // navigate to content home page or rewards page
    navigate(redirectPath as string, {
      state: { fromOnboarding: true },
    });
  };

  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'center',
    }}>
      <Typography sx={{
        fontWeight: 600,
        color: theme.palette.brand.primary,
        mt: theme.spacing(2.5),
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: theme.palette.brand.surface,
        },
        ...(optionalTextStyles || {}),
      }}
      data-testid={TestIds.onboarding.homedepotXtraLaterLnk}
      onClick={onClickHandler}
      >
        {t('hdSetUpWeb.postponeText')}
      </Typography>
    </Box>
  );
}
